import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class DialogMarkThreadAsCompleted {

    private _onContinue: () => Promise<void>;

    constructor(private dialogClientService: DialogClientService) { }

    activate(model: { onContinue: () => Promise<void> }) {
        this._onContinue = model.onContinue;
    }

    //Close
    public close() {
        this.dialogClientService.hide();
    }

    //Continue
    public async continue() {
        this._onContinue();
        this.close();
    }
}